/**
 * 活动类型，目前一共有9种，如大转盘，自定义表单，专题活动等
 */
export const ActivityType = {
  /**
   * "4": 门店导航
   */
  storeNavigation: "4",

  /**
   * "5": 自定义表单
   */
  customForm: "5",

  /**
   * "6": 积分兑换活动
   */
  pointConversion: "6",

  /**
   * "7": 专题活动
   */
  thematicActivity: "7",

  /**
   * "8": 活动编排
   */
  activityArrangement: "8",

  /**
   * "9": 大转盘
   */
  bigTurnable: "9",

  /**
   * "10": 新品预约
   */
  newProductsReservation: "10",
  /**
   * "11": NPS模板活动
   */
  NPSTemplateActivity: "11",
  /**
   * "12": 签到
   */
  signIn: "12",
  /**
   * "21": 签到有礼
   */
  signInGift: "21",
  /**
   * "22": 活动管理
   */
  activityManagement: "22"
};

/**
 * 活动状态：一共有4种状态：0-未开始，1-进行中，2-已暂停，3-已结束
 */
export const ActivityStatus = {
  /**
   * "0": 未开始
   */
  notStarted: "0",

  /**
   * "1": 进行中
   */
  running: "1",

  /**
   * "2": 已暂停
   */
  paused: "2",

  /**
   * "3": 已结束
   */
  finished: "3"
};
/**
 * 普通表单进行中的活动设置填写时间，包括：0-当天的未开始（倒计时展示），1-当天的进行中，2-当天的已结束（时间区间展示）
 */
export const TimeIntervalState = {
  /**
   * "0": 未开始
   */
  notStarted: "0",
  /**
   * "1": 进行中
   */
  running: "1",
  /**
   * "2": 已结束
   */
  finished: "2"
};
/**
 * 普通表单填写次数限制，包括：每日:day、每月:month、总共:total、无限制:none
 */
export const QuestionLimitPeriodCondition = {
  /**
   * "day": 每日
   */
  day: "day",
  /**
   * "month": 每月
   */
  month: "month",
  /**
   * "total": 总共
   */
  total: "total",
  /**
   * "none": 无限制
   */
  none: "none"
};
/**
 * 自定义表单类型，包括：0-普通表单，1-话题PK，2-趣味表单
 */
export const FormType = {
  /**
   * "0": 普通表单
   */
  commonForm: "0",

  /**
   * "1": 话题PK
   */
  topicPK: "1",

  /**
   * "2": 趣味表单
   */
  interestForm: "2"
};

/**
 * 活动样式，包括：1-大转盘，2-盲盒，3-轮盘锦鲤（老虎机），4-新盲盒
 */
export const BigWheelActivityType = {
  /**
   * "1": 大转盘
   */
  bigTurnable: "1",

  /**
   * "2": 盲盒
   */
  blindBox: "2",

  /**
   * "3": 轮盘锦鲤（老虎机）
   */
  tigerMachine: "3",

  /**
   * "4": 新盲盒
   */
  newBlindBox: "4"
};

/**
 * 抽奖类型，包括：1-普通抽奖，2-整点购抽奖，3-定时开奖
 */
export const DrawWheelType = {
  /**
   * "1": 普通抽奖
   */
  ordinaryDraw: "1",

  /**
   * "2": 整点购抽奖
   */
  purchaseOnHourDraw: "2",

  /**
   * "3": 定时开奖
   */
  timedDraw: "3"
};

/**
 * 奖品类型，包括：0-未中奖，1-虚拟奖品，2-实物奖品，3-优惠券，4-积分，5-代金券
 */
export const GoodsType = {
  /**
   * "0": 未中奖
   */
  noAward: "0",

  /**
   * "1": 虚拟奖品
   */
  virtualAward: "1",

  /**
   * "2": 实物奖品
   */
  entityAward: "2",

  /**
   * "3": 优惠券
   */
  coupon: "3",

  /**
   * "4": 积分
   */
  accumulatePoints: "4",

  /**
   * "5": 代金券
   */
  voucher: "5",
  /**
   * "6": 赠品券
   */
  giftCoupon: "6"
};

/**
 * 奖品领取类型，包括：1-邮寄(实物)/线上兑换(虚拟)，2-到店自提(实物)/线下核销(虚拟)，3-线下核销发串码(虚拟)) ，4-免单抽奖，5-货柜自取
 */
export const CollectionType = {
  /**
   * "1": 邮寄(实物)/线上兑换(虚拟)
   */
  expressOrOnlineCheckOff: "1",

  /**
   * "2": 到店自提(实物)/线下核销(虚拟)
   */
  inStore: "2",

  /**
   * "3": 线下核销发串码(虚拟))
   */
  checkOffStrCode: "3",

  /**
   * "4": 免单抽奖
   */
  freeOfCharge: "4",

  /**
   * "5": 货柜自取
   */
  containerPickup: "5"
};

/**
 * 定时开奖状态，包括：
 * 1-活动已结束,用户有中奖，
 * 2-活动已结束,用户未中奖，
 * 3-活动已结束,但是用户未参与过活动，
 * 4-活动进行中,用户无抽奖次数，
 * 5-活动进行中,用户有抽奖次数，
 * 6-活动已结束,但是活动中奖逻辑还在计算中(开奖中)
 */
export const RegularDrawShowStatus = {
  /**
   * "1": 活动已结束,用户有中奖
   */
  winPrizes: "1",

  /**
   * "2": 活动已结束,用户未中奖
   */
  failToWin: "2",

  /**
   * "3": 活动已结束,但是用户未参与过活动
   */
  noParticipate: "3",

  /**
   * "4": 活动进行中,用户无抽奖次数
   */
  noChance: "4",

  /**
   * "5": 活动进行中,用户有抽奖次数
   */
  hasChance: "5",

  /**
   * "6": 活动已结束,但是活动中奖逻辑还在计算中(开奖中)
   */
  runningLotteries: "6"
};

/**
 * 小程序类型，包括：1-HI荣耀小程序，2-直营店小程序
 */
export const MiniType = {
  /**
   * "1": HI荣耀小程序
   */
  HiHonor: "1",

  /**
   * "2": 直营店小程序
   */
  HonorBrand: "2"
};

/**
 * 权益品类型，包括：0-虚拟，1-实物，2-优惠券，3-积分，4-代金券，5-赠品券
 */
export const ExchangeGoodsType = {
  /**
   * "0": 虚拟
   */
  virtualAward: "0",

  /**
   * "1": 实物
   */
  entityAward: "1",

  /**
   * "2": 优惠券
   */
  coupon: "2",

  /**
   * "3": 积分
   */
  accumulatePoints: "3",

  /**
   * "4": 代金券
   */
  voucher: "4",

  /**
   * "5": 赠品券
   */
  giftCoupon: "5"
};

/**
 * 按钮跳转配置类型: 0小程序代金券列表;1小程序首页;2自定义链接;3入会好礼各奖品默认页面;4小程序优惠券列表;5小程序积分;6奖励查询;9无跳转;10我的页面;11小程序免息券列表;
 */
export const JumpType = {
  /**
   * "0": 小程序代金券列表
   */
  voucherPage: "0",

  /**
   * "1": 小程序首页
   */
  homePage: "1",

  /**
   * "2": 自定义链接
   */
  customLink: "2",

  /**
   * "4": 小程序优惠券列表
   */
  couponPage: "4",

  /**
   * "5": 小程序积分
   */
  pointsPage: "5",

  /**
   * "6": 奖励查询
   */
  rewardInquiry: "6",

  /**
   * "9": 无跳转
   */
  noJump: "9",
  /**
   * "10": 小程序我的
   */
  my: "10",

  /**
   * "11": 小程序免息券列表
   */
  interestFreePage: "11"
};

/**
 * 签到活动状态：'0'：未开始，'1'：进行中，'2'：已暂停，'3'：已结束
 */
export const SignInStatus = {
  /**
   * '0'：未开始
   */
  notStarted: "0",
  /**
   * '1'：进行中
   */
  running: "1",
  /**
   * '2'：已暂停
   */
  paused: "2",
  /**
   * '3'：已结束
   */
  finished: "3"
};

/**
 * 签到奖品状态：0、待生效 1、已使用 2、 去使用  3、未达到条件/去完成 4、已领完 5、待领取 6、已过期
 */
export const SignInGiftStatus = {
  /**
   * 0、待生效
   */
  readyToTakeEffect: 0,
  /**
   * 1、已使用
   */
  used: 1,
  /**
   * 2、去使用
   */
  readyToUse: 2,
  /**
   * 3、未达到条件/去完成
   */
  notMeetConditions: 3,
  /**
   * 4、已领完
   */
  takeAll: 4,
  /**
   * 5、待领取
   */
  readyToTake: 5,
  /**
   * 6、已过期
   */
  expired: 6
};

/**
 * 预约导购标识，包括："1"：需要预约导购（可能，还需结合奖品类型和领取方式进行判断），"0"：不需要预约导购
 */
export const AppointmentFlag = {
  /**
   * "1"：需要预约导购（可能，还需结合奖品类型和领取方式进行判断）
   */
  need: "1",
  /**
   * "0"：不需要预约导购
   */
  noNeed: "0"
};
/**
 * 签到方式 '0'：手动，'1'：自动
 */
export const SignInCheckInType = {
  /**
   * '0'：手动
   */
  manualCheckIn: "0",
  /**
   * '1'：自动
   */
  automaticCheckIn: "1"
};

/**
 * 登录方式，包括"wechat"-微信，"Alipay"-支付宝，"allLogin"：全部登录类型，即微信+支付宝
 */
export const LoginType = {
  /**
   * "wechat"：微信
   */
  Wechat: "wechat",
  /**
   * "Alipay"：支付宝
   */
  Alipay: "Alipay",
  /**
   * 全部登录类型，即微信+支付宝，需使用方法isAllLogin判断，该枚举值仅做参考
   */
  All: "wechat,Alipay",
  /**
   * "none"：无需登录
   */
  None: "none"
};
/**
 * 开启消息订阅通知,开启就是"1"，不开启就是"0"
 */
export const EnableMessageNotifications = {
  /**
   * '0'：关闭
   */
  close: "0",
  /**
   * '1'：开启
   */
  open: "1"
};

/**
 * 签到任务类型，'0'连续签到奖励、'1'累计签到领奖励、'2'指定日期签到奖励、'3'线下门店签到
 */
export const SignInTaskType = {
  /**
   * '0'连续签到奖励
   */
  continuousCheckIn: "0",
  /**
   * '1'累计签到领奖励
   */
  accumulatedCheckIn: "1",
  /**
   * '2'指定日期签到奖励
   */
  appointedDateCheckIn: "2",
  /**
   * '3'线下门店签到
   */
  offlineStoreCheckIn: "3"
};

/**
 * 签到有礼
 */
export const SignInGiftRewardButtonStatus = {
  //   // 0:已领取,不需要预约导购;1:已领取,需要预约导购;2:已预约;3:已核销;4:用户未参与,活动终止;5:用户未参与,线下签到(签到);
  // 6:用户未参与,线上预约(线上预约);7:用户未参与,活动已暂停;8:用户未参与,任务未开始;9:用户未参与,任务已结束;10:已领取,权益品已过期;
  // 11:已领取,无奖品;12:用户未参与,线上预约(线上预约) 无绑定表单活动
  /**
   * 0、去使用（不跳预约导购）
   */
  noReservationReceived: "0",
  /**
   * 1、去使用（跳预约导购）
   */
  toUse: "1",
  /**
   * 2、已预约
   */
  rappointmentToUse: "2",
  /**
   * 3、已核销（已签到）
   */
  writtenOff: "3",
  /**
   * 4、活动已暂停（终止）
   */
  activityTerminated: "4",
  /**
   * 5、签到（未预约，线上签到）
   */
  signInWithoutAppointment: "5",
  /**
   * 6、线上预约（有表单）
   */
  appointmentForm: "6",
  /**
   * 7、活动已暂停
   */
  activityPaused: "7",
  /**
   * 8、活动未开始（任务未开始）
   */
  taskNotStarted: "8",
  /**
   * 9、活动已结束（任务已结束）
   */
  taskEnded: "9",
  /**
   * 10、已领取,权益品已过期
   */
  goodsExpired: "10",
  /**
   * 11、无奖品
   */
  noPrize: "11",
  /**
   * 12、线上预约（无表单）
   */
  appointment: "12"
};

/**
 * 任务子类型:1:指定日期线下签到;2:指定日期线上预约
 */
export const TaskSubtype = {
  /**
   * 1:指定日期线下签到;
   */
  offlineSignIn: "1",
  /**
   * 2:指定日期线上预约
   */
  onlineAppointment: "2"
};

/**
 * 任务类型;1:指定日期线下签到;2:指定日期线上预约线下签到
 */
export const TaskType = {
  /**
   * 1:指定日期线下签到;
   */
  offlineSignIn: "1",
  /**
   * 2:指定日期线上预约线下签到
   */
  onlineAppointmentAndOfflineSignIn: "2"
};

/**
 * 将要跳转的页面
 */
export const JumpToPage = {
  /**
   * pointsMall：积分商城
   */
  pointsMall: "pointsMall"
};

/**
 * 积分商城的链接类型
 */
export const PMLinkType = {
  /**
   * 短链
   */
  shortLink: "1",
  /**
   * 完整链接
   */
  fullLink: "2",

  /**
   * 未匹配
   */
  notMatch: "0"
};

/**
 * 积分商城链接
 */
export const POINTS_MALL_URL_LIST = [
  "umm-cn.honor.com/h5/myHonor/points-mall/index.html",
  "umm-uat.test.honor.com/h5/myHonor/points-mall/index.html",
  "selfservice-mng-cn.hihonor.com/h5/myHonor/points-mall/index.html",
  "selfservice-mng-sit.hihonor.com/h5/myHonor/points-mall/index.html",
  "umm-sit.test.honor.com/h5/myHonor/points-mall/index.html"
];

/**
 * 专题活动的优惠券，代金券和大转盘活动身份验证字段
 */
export const IdentityVerify = {
  /**
   * 2-1:老用户
   */
  oldUser: "2-1",
  /**
   * 2-2:新用户
   */
  newUser: "2-2",
  /**
   * 3-1:芝麻学生
   */
  student: "3-1",
  /**
   * 3-2:芝麻老师
   */
  teacher: "3-2",
  /**
   * 3-3:芝麻医护
   */
  medicalWorkers: "3-3",
  /**
   * 3-4:支付宝学生认证
   */
  alipayStudent: "3-4",
  /**
   * 3-5：芝麻信用
   */
  zhiMaCredit: "3-5",
  /**
   * 4-1:微信学生认证
   */
  weChatSchool: "4-1",
  /**
   * 5-1:edu教育认证
   */
  eduEducation: "5-1"
};

/**
 * 专题活动 大转盘顾客群体字段
 */
export const CustomerGroup = {
  /**
   * 0: 无限制
   */
  noLimit: "0",
  /**
   * 2: 新老用户
   */
  newOldUser: "2",
  /**
   * 999: 多方式验证
   */
  multimodalVerification: "999"
};

/**
 * 专题活动券类型
 */
export const CouponType = {
  /**
   * 权益品
   */
  exchangegoods: "exchangegoods",
  /**
   * 代金券
   */
  voucher: "voucher",
  /**
   * 优惠券
   */
  coupon: "coupon",
  /**
   * 免息券
   */
  offinterest: "offinterest",
  /**
   * 权益包
   */
  EQUITY_PACKAGE: "group"
};

/**
 * 大转盘参加活动，当前顾客身份验证不通过，是否开启去参加其他活动按钮显示
 */
export const ShowOtherActivity = {
  /**
   * 1显示
   */
  display: "1",
  /**
   * 0关闭
   */
  close: "0"
};

/**
 * 专题活动：优惠券/免息券/权益品使用状态
 * "01":未领用 "02":已领用 "03":已占用 "04":作废 "05":已使用 "06":已过期 "07":未到领取时间 "08":超过领取时间 "09":未到使用时间
 * "10":超过使用时间 "11":已领完 "12":已领完（实际是已下架状态） "13":去使用 "14":不可领取 "15":去填写
 */
export const useStatus = {
  /**
   * "01":未领用
   */
  unreceived: "01",
  /**
   * "02":已领用
   */
  received: "02",
  /**
   * "03":已占用
   */
  occupied: "03",
  /**
   * "04":作废
   */
  abolished: "04",
  /**
   * "05":已使用
   */
  used: "05",
  /**
   * "06":已过期
   */
  expired: "06",
  /**
   * "07":未到领取时间
   */
  notArrivedRecTime: "07",
  /**
   * "08":超过领取时间
   */
  exceedRecTime: "08",
  /**
   * "09":未到使用时间
   */
  notArrivedUseTime: "09",
  /**
   * "10":超过使用时间
   */
  exceedUseTime: "10",
  /**
   * "11":已领完
   */
  hasReceivedAll: "11",
  /**
   * "12":已领完（实际是已下架状态）
   */
  delist: "12",
  /**
   * "13"去使用
   */
  toUse: "13",
  /**
   * "14"不可领取
   */
  cannotReceived: "14",
  /**
   * "15"去填写
   */
  TO_FILL: "15"
};

/**
 * 活动列表页-活动导购状态(展示用)=> 01：去参与;02:未预约;03:已预约
 */
export const activityGuideType = {
  /**
   * '01'：去参与
   */
  toJoin: "01",
  /**
   * '02':未预约
   */
  noReservation: "02",
  /**
   * '03':已预约
   */
  alreadyBooked: "03"
};

/**
 * 活动列表页-预约单真实状态=>1:已预约,2:已到店,3:已评价,4:已取消
 */
export const appointmentStatus = {
  /**
   * '1':已预约
   */
  alreadyBooked: "1",
  /**
   * '2':已到店
   */
  arrivedAtTheStore: "2",
  /**
   * '3':已评价
   */
  rated: "3",
  /**
   * '4':已取消
   */
  canceled: "4"
};

/**
 * 分享开关 1、开启 2、关闭
 */
export const shareSwitch = {
  /**
   * '1': 开启
   */
  open: "1",
  /**
   *  '2': 关闭
   */
  close: "2"
};
/**
 * 作用：根据优惠券免息券绑定的商品范围决定跳转的小程序页面
 * 枚举：01: 全部商品； 02: 多个商品； 03: 单个商品。
 */
export const SkuScopeType = {
  allProducts: "01",
  moreProducts: "02",
  singleProduct: "03"
};

/**
 * 用户身份限制状态(-2: 未登录, -1: 活动、权益品、权益包无限制, 1: 用户满足条件, 2: 用户企微好友时间不满足 3：用户加入社群时间不满足 4：用户入会时间不满足 5:需要用户加企微, 6:需要用户入群)
 */
export const USER_LIMIT_STATUS = {
  /**
   * '-2': 未登录
   */
  NOT_LOGIN: -2,
  /**
   * '-1': 活动、权益品、权益包无限制
   */
  NO_LIMIT: -1,
  /**
   * '1': 用户满足条件
   */
  PASS: 1,
  /**
   * '2': 用户企微好友时间不满足
   */
  QY_WECHAT_GUIDE_TIME_LIMIT: 2,
  /**
   * '3'：用户加入社群时间不满足
   */
  COMMUNITY_USER_TIME_LIMIT: 3,
  /**
   * '4'：用户入会时间不满足
   */
  JOIN_MEMBER_TIME_LIMIT: 4,
  /**
   * '5':需要用户加企微
   */
  NOT_ADD_QY_WECHA_GUIDE_LIMIT: 5,
  /**
   * '6':需要用户入群
   */
  NOT_ADD_COMMUNITY_LIMIT: 6
};

/**
 * 非企微好友引导加好友 ('0':不设置, '1':消费者最近门店导购企微二维码, '2':设置-自定义)
 */
export const QY_WECHAT_JOIN_PATH_CONFIG = {
  /**
   * '0':不设置
   */
  NO_SETTING: "0",
  /**
   * '1':消费者最近门店导购企微二维码
   */
  CHANNEL_STORE_GUIDE_QR_CODE: "1",
  /**
   * '2':设置-自定义
   */
  SET_CUSTOMIZE_LINK: "2"
};

/**
 * 非社群用户引导入群路径 ('0':不设置, '1':设置-活码地址, '2':设置-自定义)
 */

export const COMMUNITY_JOIN_PATH_CONFIG = {
  /**
   * '0':不设置
   */
  NO_SETTING: "0",
  /**
   * '1':设置-活码地址
   */
  SET_LIVE_CODE: "1",
  /**
   * '2':设置-自定义
   */
  SET_CUSTOMIZE_LINK: "2"
};
/**
 * 未入会引导其他活动地址开关 ('1': 开启, '0': 关闭)
 */
export const MEMBER_PAGE_PATH_CONFIG = {
  /**
   * '1': 开启
   */
  OPEN: "1",
  /**
   * '0': 关闭
   */
  CLOSE: "0"
};
/**
 * 接口状态：200，成功
 */
export const HTTP_STATUS = {
  /**
   * 成功
   */
  SUCCESS: 200
};
/**
 * 权益包状态
 */
export const EQUITY_PACKAGE_STATUS = {
  /**
   * 未领取
   */
  UN_RECEIVE: "0",
  /**
   * 已领取
   */
  RECEIVED: "1",
  /**
   * 已过期
   */
  EXPIRED: "2"
};
/**
 * 是否开启社群、企微好友及入会时间限制（'0':否;'1':是）
 */
export const USER_RESTRICTIONS_FLAG = {
  /**
   * '1':是
   */
  YES: "1",
  /**
   * '0':否
   */
  NO: "0"
};
/**
 * 签到类型 '0'：普通签到，'1'：线上预约线下签到，'2'：线下签到
 */
export const CHECK_IN_CATEGORY = {
  /**
   * '0'：普通签到
   */
  REGULAR_CHECK_IN: "0",
  /**
   * '1'：线上预约线下签到
   */
  APPOINTMENT_CHECK_IN: "1",
  /**
   * '2'：线下签到
   */
  OFFLINE_CHECK_IN: "2"
};
/**
 * 任务状态
 * 0：未跟进（邀请：去邀请：普通：去添加，说明任务已经开始不置灰）
 * 1：已完成（已完成，去抽奖）
 * 2.跟进中（展示去邀请，去抽奖）
 * 3.未开始（邀请：去邀请：普通：去添加，按钮均要置灰不可点击）
 * 4.已结束（去查看）
 */
export const TASK_STATUS = {
  //   任务状态

  // 0：未跟进(普通:去添加)
  // 1：任务进行中-已完成(普通:已完成,去抽奖)
  // 2：未开始(普通)
  // 3：已结束-未参与(普通)
  // 4：聚合码不满足条件（普通：已添加过好友且好友关系时间不满足条件or活动开始时间大于好友关系的建立时间）
  // 5：任务已结束-已参与-（普通：已完成）
  // 10：未跟进(邀请:去添加)
  // 11：任务进行中-已完成（邀请:去邀请,去抽奖)
  // 12：任务进行中-有次数-跟进中（邀请:去邀请,去抽奖）;
  // 13：未开始(邀请)
  // 14：已结束-未参与(邀请);
  // 15：任务跟进中-没有次数（展示去邀请，不展示抽奖）
  // 16：任务已结束-已参与-（邀请：送过抽奖次数）
  // 17：任务已结束-已参与-（邀请：没送过）

  /**
   * 0：普通任务已开始，未完成
   */
  GENERAL_STARTED_NOT_COMPLETED: "0",
  /**
   * 1：普通任务已开始，已完成
   */
  GENERAL_STARTED_COMPLETED: "1",
  /**
   * 2.普通任务未开始
   */
  GENERAL_NOT_STARTED: "2",
  /**
   * 3.普通任务已结束，未参与
   */
  GENERAL_ENDED_NOT_COMPLETED: "3",
  /**
   * 4.不符合条件，例如以前已经加了好友，不能再加了
   */
  GENERAL_NOT_MEET_REQUIREMENTS: "4",
  /**
   * 5.普通任务已结束，已参与
   */
  GENERAL_ENDED_COMPLETED: "5",

  /**
   * 10：邀请任务进行中，未邀请
   */
  INVITATION_STARTED_NOT_INVITED: "10",
  /**
   * 11：邀请任务进行中，已完成
   */
  INVITATION_STARTED_COMPLETED: "11",
  /**
   * 12：邀请任务进行中，有抽奖机会
   */
  INVITATION_STARTED_HAS_CHANCES: "12",
  /**
   * 13：邀请任务未开始
   */
  INVITATION_NOT_STARTED: "13",
  /**
   * 14：邀请任务已结束，未邀请
   */
  INVITATION_ENDED_NOT_INVITED: "14",
  /**
   * 15：邀请任务已开始，已邀请，但无抽奖机会
   */
  INVITATION_STARTED_INVITED_NO_CHANCES: "15",
  /**
   * 16：邀请任务已结束，已邀请，有抽奖机会
   */
  INVITATION_ENDED_INVITED_HAS_CHANCES: "16",
  /**
   * 17：邀请任务已结束，已邀请，无抽奖机会
   */
  INVITATION_ENDED_INVITED_NO_CHANCES: "17"

  /**
   * 普通任务：
   * 时间状态   0：未开始   1：进行中   2：已结束
   * 以前有无添加状态   0：未添加   1：已添加
   * 有无参与状态   0：未参与   1：已参与
   * 邀请任务：
   * 时间状态   0：未开始   1：进行中   2：已结束
   * 有无参与状态   0：未参与   1：已参与
   * 有无机会状态   0：无机会   1：有机会
   */
};
/**
 * 任务类型
 */
export const TASK_TYPE = {
  /**
   * 普通任务
   */
  GENERAL_TASK: "generalTask",
  /**
   * 邀请任务
   */
  INVITATION_TASK: "invitationTask"
};
/**
 * 图片类型展示
 */
export const IMAGE_SHOW_TYPE = {
  /**
   * 已完成图片
   */
  COMPLETED: "completed",
  /**
   * 未开始图片
   */
  NOT_STARTED: "notStart",
  /**
   * 已结束图片
   */
  ENDED: "ended"
};
/**
 * 组件类型
 */
export const COMPONENT_TYPE = {
  /**
   * 登录组件
   */
  LOGIN_COMPONENT: "1",
  /**
   * 任务组件
   */
  TASK_COMPONENT: "2",
  /**
   * 图片组件
   */
  IMAGE_COMPONENT: "3"
};



// WEBPACK FOOTER //
// ./src/commons/commonVariables.js